var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar-wrapper"},[_c('v-text-field',{ref:"searchInput",staticClass:"search-box search",attrs:{"append-outer-icon":"search","label":_vm.$language.translate('Search products'),"id":"search"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }